import { useDeepEqualMemo } from '@xolv-mybrightlink/common';
import { useCareTeamSelector } from './useCareTeamSelector';
import { useCallback } from 'react';

export const useUserGuids = (): string[] => {
  const userGuids = useCareTeamSelector(
    useCallback((state) => {
      return state === 'LOADING' ? [] : Object.keys(state.users).sort();
    }, []),
  );
  return useDeepEqualMemo(userGuids);
};
